(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-translation', {
            parent: 'entity',
            url: '/public-site-translation?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation/public-site-translations.html',
                    controller: 'PublicSiteTranslationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslation');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-translation-detail', {
            parent: 'entity',
            url: '/public-site-translation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-detail.html',
                    controller: 'PublicSiteTranslationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteTranslation', function($stateParams, PublicSiteTranslation) {
                    return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-translation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-translation-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-dialog.html',
                    controller: 'PublicSiteTranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslation', function(PublicSiteTranslation) {
                            return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-dialog.html',
                    controller: 'PublicSiteTranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                message: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-translation', null, { reload: 'public-site-translation' });
                }, function() {
                    $state.go('public-site-translation');
                });
            }]
        })
        .state('public-site-translation.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-dialog.html',
                    controller: 'PublicSiteTranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslation', function(PublicSiteTranslation) {
                            return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation', null, { reload: 'public-site-translation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-delete-dialog.html',
                    controller: 'PublicSiteTranslationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteTranslation', function(PublicSiteTranslation) {
                            return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation', null, { reload: 'public-site-translation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
